import {Component, HostBinding, Input, OnInit} from '@angular/core';
import {djangourl} from '../../../assets/urls';
import {HttpClient} from '@angular/common/http';
import {DomSanitizer} from '@angular/platform-browser';

@Component({
  selector: 'app-price-box',
  templateUrl: './price-box.component.html',
  styleUrls: ['./price-box.component.scss']
})
export class PriceBoxComponent implements OnInit {
  loading_overlay = true;
  @Input() id;
  productUrl = djangourl + 'api/products/';
  product: any = {
    price: '',
    discount: '',
  };
  @Input() color;
  @Input() whatsapp;

  @HostBinding("attr.style")
  public get valueAsStyle(): any {
    return this.sanitizer.bypassSecurityTrustStyle(`--product-color: ${this.color}`);
  }

  constructor(private http: HttpClient, private sanitizer: DomSanitizer) { }

  ngOnInit() {
    this.http.get(this.productUrl + this.id).subscribe(data => {
      this.product = data;
      this.loading_overlay = false;
    });
  }


  numberWithCommas(x) {
    return (Math.floor(x)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  toint(x) {
    return Math.round(x);
  }


}
